import React from 'react';

import EcoCardIllustration from '../../../assets/svg-components/eco/background_leaves.svg';
import { SectionContent } from '../../../components/section/section-content';
import { SectionHero } from '../../../components/section/section-hero';
import { SectionTitle } from '../../../components/section/section-title';
import { SvgWithGenericAnimation } from '../../../components/svg-with-generic-animation/svg-with-generic-animation';
import { Translate } from '../../../components/translate';
import { EcoCard } from './eco-card';
import './eco-section.scss';
import { EcoCardTreesIllustration } from './tree-svg/tree-svg';

interface EcoSectionProps {
  score?: string;
  grams?: number;
}

const EcoSection: React.FC<EcoSectionProps> = ({ score, grams }) => {
  const percent_score = score?.split('_')[2];

  return (
    <React.Fragment>
      <SectionHero className="rc-eco-section">
        <img src="https://www.siteground.com/static/en/img/recap2023/05-BG.png" alt="eco section image" />

        <SectionTitle>
          <Translate id="translate.eco.section.title" />
        </SectionTitle>
      </SectionHero>

      <SectionContent className="rc-eco-section">
        <EcoCard
          icon={<SvgWithGenericAnimation name="carbon-footprint" />}
          title={
            percent_score ? (
              <Translate id="translate.personal.eco.card.co2.reduction.title" values={{ co2: percent_score }} />
            ) : (
              <Translate id="translate.eco.card.co2.reduction.title" />
            )
          }
          text={
            <React.Fragment>
              {percent_score ? (
                <Translate
                  id="translate.personal.eco.card.co2.reduction.text"
                  values={{ co2_grams: grams, co2_score: percent_score }}
                />
              ) : (
                <Translate id="translate.eco.card.co2.reduction.text" />
              )}
              <p className="rc-eco-card__co2-source-link">
                <Translate
                  id="translate.eco.card.co2.reduction.text.source.link"
                  customStyles={{ a: { color: '#316641', fontWeight: 'normal', fontStyle: 'italic' } }}
                />
              </p>
            </React.Fragment>
          }
        >
          <EcoCardIllustration className="rc-eco-card--co2-reduction_illustration-top" />
        </EcoCard>

        <EcoCard
          reverted
          icon={<EcoCardTreesIllustration width="100%" />}
          title={<Translate id="translate.eco.card.planted.trees.reduction.title" />}
          text={<Translate id="translate.eco.card.planted.trees.reduction.text" />}
        />

        <EcoCard
          icon={<SvgWithGenericAnimation name="guinness-records" />}
          title={<Translate id="translate.eco.card.guinness.records.reduction.title" />}
          text={<Translate id="translate.eco.card.guinness.records.reduction.text" />}
        >
          <EcoCardIllustration className="rc-eco-card--co2-reduction_illustration-bottom" />
        </EcoCard>
      </SectionContent>
    </React.Fragment>
  );
};

export default EcoSection;
